module.exports = __webpack_public_path__ + "img/Vintage-Frame_fr.1f353232.jpg";